import moment from 'moment';

export function formatDate(raw: number): string {
  return moment(raw).format('HH:mm  MMM DD YYYY');
}
